import { useLog } from './useLog'

export function useCoreLog(subSpace?: string) {
  return useLog(subSpace ? `sfc.${subSpace}` : 'sfc')
}
